import React from "react";
import styled from "styled-components";
import {
  GridHeaderCellProps,
  GridColumnMenuWrapper,
} from "@progress/kendo-react-grid";
import {
  FilterDescriptor,
  isCompositeFilterDescriptor,
} from "@progress/kendo-data-query";

const CellInner = styled.span`
  .k-column-title {
    margin-inline-end: 7px !important;
  }
  .k-link .k-icon {
    margin-inline-start: 0 !important;
  }
  .k-i-filter-small {
    color: #1468a5;
  }
`;

const HeaderCell = (props: GridHeaderCellProps) => {
  const filterValues = props.columnMenuWrapperProps?.filter?.filters
    ?.map((f) => (isCompositeFilterDescriptor(f) ? f.filters : [f]))
    .reduce((p, n) => p.concat(n), []);
  const isColumnFiltered = filterValues?.some(
    (filter) => (filter as FilterDescriptor).field === props.field
  );
  return (
    <CellInner className="k-cell-inner">
      <span className="k-link" onClick={props.onClick}>
        <span className="k-column-title">{props.title}</span>
        {isColumnFiltered && <span className="k-icon k-i-filter-small" />}
        {props.children}
      </span>
      <GridColumnMenuWrapper
        {...props.columnMenuWrapperProps}
      ></GridColumnMenuWrapper>
    </CellInner>
  );
};

export default HeaderCell;
